import React from 'react';
type PageType = 'home' | 'commercial' | 'services' | 'residential' | 'reservation' | 'cinema';
interface ResidentialSolutionsProps {
  onNavigate: (page: PageType) => void;
}
const services: {
  label: string;
  page?: PageType;
}[] = [{
  label: 'smart house'
}, {
  label: 'high end audio'
}, {
  label: 'privátní kinosál',
  page: 'cinema'
}, {
  label: 'FVE'
}];
export function ResidentialSolutions({
  onNavigate
}: ResidentialSolutionsProps) {
  return <section id="rezidentni" className="w-full bg-white py-12" data-id="element-183">
      <div className="max-w-6xl mx-auto px-6" data-id="element-184">
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_1.6fr] gap-16 items-start" data-id="element-185">
          {/* Left Column - Services List */}
          <div className="flex flex-col items-end text-right" data-id="element-186">
            <h2 className="text-2xl font-normal text-[#707070] tracking-wide mb-8" data-id="element-187">
              REZIDENTNÍ ŘEŠENÍ
            </h2>
            <ul className="space-y-2" data-id="element-188">
              {services.map(service => <li key={service.label} data-id="element-189">
                  <a href="#" onClick={e => {
                e.preventDefault();
                if (service.page) onNavigate(service.page);
              }} className="flex items-center justify-end gap-3 text-[#707070] hover:text-[#404040] transition-colors group py-1" data-id="element-190">
                    <span className="text-base" data-id="element-191">{service.label}</span>
                    <img src="https://cdn.magicpatterns.com/uploads/ngsUE6r4TLTc8etnh6qeyU/sipka.png" alt="" className="h-[10px] w-auto opacity-60 group-hover:opacity-100 transition-opacity scale-x-[-1]" data-id="element-192" />
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Right Column - Image */}
          <div className="w-full" data-id="element-193">
            <img src="https://images.unsplash.com/photo-1558002038-1055907df827?w=1200&h=800&fit=crop&auto=format&q=80" alt="Rezidentní řešení - smart home" className="w-full h-auto grayscale" data-id="element-194" />
          </div>
        </div>
      </div>
    </section>;
}